import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page-heading" }
const _hoisted_3 = {
  key: 0,
  class: "settings-nav imports-nav"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["value"]
const _hoisted_6 = ["max"]
const _hoisted_7 = ["min"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 0,
  class: "notice error"
}
const _hoisted_10 = {
  key: 1,
  class: "notice"
}
const _hoisted_11 = { class: "panel table-panel" }
const _hoisted_12 = { class: "error" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "queue-summary" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "notice error"
}
const _hoisted_20 = { class: "panel table-panel queue-table" }
const _hoisted_21 = {
  key: 0,
  class: "error"
}
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "queue-table-footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[10] || (_cache[10] = _createElementVNode("small", null, "Интеграции", -1 /* CACHED */)),
        _createElementVNode("h1", null, _toDisplayString($setup.section === "jobs" ? "Очередь джоб" : "Импорт"), 1 /* TEXT */)
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = $event => ($setup.section === 'jobs' ? $setup.loadJobs() : $setup.load()))
      }, "Обновить")
    ]),
    ($setup.me?.role === 'admin')
      ? (_openBlock(), _createElementBlock("nav", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass({ active: $setup.section === 'imports' }),
            onClick: _cache[1] || (_cache[1] = $event => ($setup.switchSection('imports')))
          }, "Журнал импортов", 2 /* CLASS */),
          _createElementVNode("button", {
            class: _normalizeClass({ active: $setup.section === 'jobs' }),
            onClick: _cache[2] || (_cache[2] = $event => ($setup.switchSection('jobs')))
          }, [
            _cache[11] || (_cache[11] = _createTextVNode("Solid Queue ", -1 /* CACHED */)),
            ($setup.jobCounts.total)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.jobCounts.total), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.section === 'imports')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("form", {
            class: "panel player-range-import",
            onSubmit: _withModifiers($setup.reimportRange, ["prevent"])
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "player-range-import-copy" }, [
              _createElementVNode("strong", null, "Реимпорт данных"),
              _createElementVNode("small", null, "Дни обрабатываются последовательно: все страницы одного дня, затем следующий день.")
            ], -1 /* CACHED */)),
            _createElementVNode("label", null, [
              _cache[13] || (_cache[13] = _createTextVNode("Тип данных", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.range.kind) = $event))
              }, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("option", { value: "players" }, "Данные игроков", -1 /* CACHED */),
                _createElementVNode("option", { value: "traffic" }, "Трафик", -1 /* CACHED */)
              ]))], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.range.kind]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[15] || (_cache[15] = _createTextVNode("Интеграция", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.range.connection_id) = $event)),
                required: ""
              }, [
                _cache[14] || (_cache[14] = _createElementVNode("option", {
                  value: "",
                  disabled: ""
                }, "Выберите", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.connections, (connection) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: connection.id,
                    value: connection.id
                  }, _toDisplayString(connection.name), 9 /* TEXT, PROPS */, _hoisted_5))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.range.connection_id]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[16] || (_cache[16] = _createTextVNode("Дата от", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($setup.range.from) = $event)),
                type: "date",
                max: $setup.range.to,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_6), [
                [_vModelText, $setup.range.from]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[17] || (_cache[17] = _createTextVNode("Дата до", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($setup.range.to) = $event)),
                type: "date",
                min: $setup.range.from,
                required: ""
              }, null, 8 /* PROPS */, _hoisted_7), [
                [_vModelText, $setup.range.to]
              ])
            ]),
            _createElementVNode("button", {
              class: "primary",
              disabled: $setup.queueing || !$setup.connections.length
            }, _toDisplayString($setup.queueing ? "Добавление…" : "Запустить"), 9 /* TEXT, PROPS */, _hoisted_8)
          ], 32 /* NEED_HYDRATION */),
          ($setup.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString($setup.error), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          ($setup.notice)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.notice), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("table", null, [
              _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Запуск"),
                  _createElementVNode("th", null, "Подключение"),
                  _createElementVNode("th", null, "Период"),
                  _createElementVNode("th", null, "Строк"),
                  _createElementVNode("th", null, "Статус"),
                  _createElementVNode("th")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.runs, (run) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: run.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(run.kind), 1 /* TEXT */),
                      _createElementVNode("small", null, [
                        _createVNode($setup["DualTime"], {
                          value: run.created_at
                        }, null, 8 /* PROPS */, ["value"])
                      ])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(run.connection_name), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(run.period_date || "—"), 1 /* TEXT */),
                    _createElementVNode("td", null, _toDisplayString(run.records_count), 1 /* TEXT */),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["status", run.status])
                      }, _toDisplayString(run.status), 3 /* TEXT, CLASS */),
                      _createElementVNode("small", _hoisted_12, _toDisplayString(run.error_message), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, [
                      (run.status==='failed')
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: $event => ($setup.retry(run.id))
                          }, "Повторить", 8 /* PROPS */, _hoisted_13))
                        : _createCommentVNode("v-if", true)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ], 64 /* STABLE_FRAGMENT */))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['running', 'ready', 'scheduled', 'blocked', 'failed'], (status) => {
              return _createElementVNode("button", {
                key: status,
                class: _normalizeClass(["panel", { active: $setup.jobFilters.status === status }]),
                onClick: $event => {$setup.jobFilters.status = $setup.jobFilters.status === status ? '' : status; $setup.loadJobs()}
              }, [
                _createElementVNode("small", null, _toDisplayString($setup.jobStatusLabel(status)), 1 /* TEXT */),
                _createElementVNode("strong", null, _toDisplayString($setup.jobCounts[status] || 0), 1 /* TEXT */)
              ], 10 /* CLASS, PROPS */, _hoisted_15)
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _createElementVNode("form", {
            class: "panel queue-filters",
            onSubmit: _withModifiers($setup.loadJobs, ["prevent"])
          }, [
            _createElementVNode("label", null, [
              _cache[20] || (_cache[20] = _createTextVNode("Поиск", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($setup.jobFilters.q) = $event)),
                placeholder: "Класс или Active Job ID"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, $setup.jobFilters.q]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[22] || (_cache[22] = _createTextVNode("Статус", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.jobFilters.status) = $event))
              }, [
                _cache[21] || (_cache[21] = _createElementVNode("option", { value: "" }, "Все текущие", -1 /* CACHED */)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['running', 'ready', 'scheduled', 'blocked', 'failed', 'pending'], (status) => {
                  return _createElementVNode("option", {
                    key: status,
                    value: status
                  }, _toDisplayString($setup.jobStatusLabel(status)), 9 /* TEXT, PROPS */, _hoisted_16)
                }), 64 /* STABLE_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.jobFilters.status]
              ])
            ]),
            _createElementVNode("label", null, [
              _cache[24] || (_cache[24] = _createTextVNode("Очередь", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (($setup.jobFilters.queue) = $event))
              }, [
                _cache[23] || (_cache[23] = _createElementVNode("option", { value: "" }, "Все очереди", -1 /* CACHED */)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jobQueues, (queue) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: queue,
                    value: queue
                  }, _toDisplayString(queue), 9 /* TEXT, PROPS */, _hoisted_17))
                }), 128 /* KEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, $setup.jobFilters.queue]
              ])
            ]),
            _createElementVNode("button", {
              class: "primary",
              disabled: $setup.jobsLoading
            }, _toDisplayString($setup.jobsLoading ? "Загрузка…" : "Применить"), 9 /* TEXT, PROPS */, _hoisted_18),
            _createElementVNode("button", {
              type: "button",
              onClick: $setup.resetJobFilters
            }, "Сбросить")
          ], 32 /* NEED_HYDRATION */),
          ($setup.jobsError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.jobsError), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("table", null, [
              _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "Джоба"),
                  _createElementVNode("th", null, "Очередь"),
                  _createElementVNode("th", null, "Статус"),
                  _createElementVNode("th", null, "Создана"),
                  _createElementVNode("th", null, "Запуск"),
                  _createElementVNode("th", null, "Приоритет")
                ])
              ], -1 /* CACHED */)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jobs, (job) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: job.id
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(job.class_name), 1 /* TEXT */),
                      _createElementVNode("small", null, "#" + _toDisplayString(job.id) + " · " + _toDisplayString(job.active_job_id), 1 /* TEXT */),
                      (job.error_message)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_21, _toDisplayString(job.error_class) + ": " + _toDisplayString(job.error_message), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("code", null, _toDisplayString(job.queue_name), 1 /* TEXT */)
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["job-status", job.status])
                      }, _toDisplayString($setup.jobStatusLabel(job.status)), 3 /* TEXT, CLASS */)
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode($setup["DualTime"], {
                        value: job.created_at
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode($setup["DualTime"], {
                        value: job.started_at || job.scheduled_at
                      }, null, 8 /* PROPS */, ["value"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(job.priority), 1 /* TEXT */)
                  ]))
                }), 128 /* KEYED_FRAGMENT */)),
                (!$setup.jobs.length && !$setup.jobsLoading)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [...(_cache[25] || (_cache[25] = [
                      _createElementVNode("td", {
                        colspan: "6",
                        class: "queue-empty"
                      }, "Текущих джоб не найдено", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true)
              ])
            ]),
            _createElementVNode("footer", _hoisted_23, "Показано " + _toDisplayString($setup.jobs.length) + " из " + _toDisplayString($setup.jobsTotal) + " · автообновление каждые 5 секунд", 1 /* TEXT */)
          ])
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}